import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import type { ProgramParticipationState } from "Infrastructure/Api/Api";

type ThanksToYouParticipation = {
  /** Undefined until user-info is known — callers wait, they never read "unknown" as a state. */
  state: ProgramParticipationState | undefined;
  isLoading: boolean;
};

/**
 * The current person's Díky Tobě participation (ZS-1623): NotAsked (never answered —
 * in the program, the registration wizard still asks), OptedIn, OptedOut (refused in the wizard, can
 * join later) or Withdrawn (left for good). The one place that reads it out of the React Query
 * user-info, like useHasStardustConsent; the participation mutations invalidate that query.
 */
export const useThanksToYouParticipation = (): ThanksToYouParticipation => {
  const { data: userInfo, isLoading } = useUserInfoQuery();

  return {
    state: userInfo?.thanksToYouParticipation,
    isLoading,
  };
};
